import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalsPageComponent } from './approvals-page.component';
import { AuthGuard, CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { PageTitle } from '../store-front/misc/page-title/page-title.component';
import { approvalsPageOccConfig } from './_core/approvals-page.occ';
import { AlertComponent } from '../../../components/alert/alert.component';
import { LocalLoaderComponent } from '../../../components/loader/local-loader/local-loader.component';
import { TableProComponent } from '../../../components/table-pro/table-pro.component';

@NgModule({
  declarations: [ApprovalsPageComponent],
  imports: [CommonModule, I18nModule, PageTitle, AlertComponent, LocalLoaderComponent, TableProComponent],
  providers: [
    provideConfig(approvalsPageOccConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ApprovalsPageComponent: {
          component: ApprovalsPageComponent,
          guards: [AuthGuard],
        },
      },
    }),
  ],
})
export class ApprovalsPageModule {}
